/*
 * Copyright (c) 2023. Legalbird eine Marke der R&S Internet Jewels GmbH
 */


import Imprint from "../../Imprint/Imprint";
import PageContentContainer from "../../Container/PageContentContainer";

const ImprintPage = () => {
  return (
    <PageContentContainer size={"tiny"} backgroundColor={"white"}>
      <Imprint />
    </PageContentContainer>
  );
};

export default ImprintPage;
